const { theme } = require('./theme');

module.exports.theme = theme;
